module.exports = __webpack_public_path__ + "assets/img/c75a-tv.svg";